import { render, staticRenderFns } from "./posts.html?vue&type=template&id=0a881ae4&scoped=true&external"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a881ae4",
  null
  
)

export default component.exports